var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    ref: "answerDomElement",
    class: ['container-answer', 'noselect', {
      error: _vm.error,
      disabled: _vm.disabled,
      answer: _vm.answer
    }],
    attrs: {
      "aria-label": _vm.ariaLabel,
      "data-isfocusable": "true",
      "role": "textbox",
      "tabindex": "10"
    },
    on: {
      "click": _vm.handleClick,
      "focusout": _vm.handleFocusOut,
      "focus": _vm.handleFocus
    }
  }, [_vm._l(_vm.splitWords, function (word, i) {
    return _c('span', {
      key: i,
      class: ['word', {
        answer: _vm.answer
      }]
    }, [_vm.splitWords.length > 1 && word.text === ' ' ? _c('span', {
      staticClass: "height-fix"
    }) : _vm._e(), _vm._l(word.text, function (letter, j) {
      return _c('span', {
        key: letter + word.startingIndex + j,
        class: _vm.getClass(word.text, word.startingIndex + j),
        attrs: {
          "aria-hidden": "true"
        },
        domProps: {
          "innerHTML": _vm._s(letter)
        }
      });
    })], 2);
  }), _vm.showCursor && !_vm.answer ? _c('span', {
    staticClass: "blinker"
  }, [_vm._v("_")]) : _vm._e()], 2);
}
var staticRenderFns = []

export { render, staticRenderFns }